module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/demo/charge-card/charge-card.component.sass
// module id = ./src/app/demo/charge-card/charge-card.component.sass
// module chunks = main